module.exports = __webpack_public_path__ + "img/title-bg.493f0010.png";